import { Group } from "../../models/group.model";
import * as angular from "angular";
import * as _ from "lodash";
import { GroupDataProvider } from "../../data-provider/group.dp";
import { ViewOptionsService } from "./view-options.helper";
import { FilterDataProvider } from "../../data-provider/filter.dp";
import { Filter } from "../../models/filter.model";
import { ToastUtils } from "../../helper/toast.helper";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";

declare const google;

export class PolygonService {
    public styles = {
        selected: {
            fill: {
                color: "#a000a0",
                opacity: 0.45,
            },
            stroke: {
                weight: 2,
                color: "#a000a0",
            },
        },
        active: {
            fill: {
                color: "#169265",
                opacity: 0.45,
            },
            stroke: {
                color: "#169265",
                weight: 2,
            },
        },
        done: {
            fill: {
                color: "#33CC33",
                opacity: 0.45,
            },
            stroke: {
                color: "#33CC33",
                weight: 2,
            },
        },
    };
    public selectedPolygonGroup: Group | null = null;
    public selectedPolygon: any = null;
    public polygonGroups: Group[] = [];
    public polygonUpdate: any;
    public previousEditPolygonPoints: any;
    public selectedPolygonOriginalPoints: any[];
    public groupDataProvider: GroupDataProvider;
    private viewOptionsService: ViewOptionsService;
    private viewOptions: any;
    private filterDataProvider: FilterDataProvider;
    private previousFilter: Filter;
    private readonly $interval: any;
    public cancelDrawing: boolean = false;
    public drawing: boolean = false;
    public fromShape: boolean = false;
    public windowOpts: any = {};
    public toast: ToastUtils;
    public gmap: any;
    public map: any;
    public drawingManagerControl: any = {};
    public freeDrawPoly: any;
    public editPolygonModeActive: boolean = false;
    public freeDrawingModeActive: boolean = false;
    public turfCuttingFeatureGated = false;
    public permissionProvider: PermissionCheck;
    public dialog: DialogUtils;
    public drawingManagerOptions: any;
    public previousViewOptions: any;
    public freeDrawMoveListener: any;
    public groupCountLoading: boolean;
    public prospectorMode: boolean;
    public $rootScope: any;
    public polygonProperties: any = {};

    constructor(
        $http: any,
        $rootScope: any,
        $interval: any,
        __env: any,
        GroupDataProvider: GroupDataProvider,
        ViewOptionsService: ViewOptionsService,
        ToastUtils: ToastUtils,
        PermissionCheck: PermissionCheck,
        FilterDataProvider: FilterDataProvider,
        DialogUtils: DialogUtils
    ) {
        this.$interval = $interval;
        this.$rootScope = $rootScope;
        this.groupDataProvider = GroupDataProvider;
        this.viewOptionsService = ViewOptionsService;
        this.viewOptions = this.viewOptionsService.getViewOptions();
        this.permissionProvider = PermissionCheck;
        this.filterDataProvider = FilterDataProvider;
        this.dialog = DialogUtils;
        this.toast = ToastUtils;
        this.drawingManagerOptions = {
            drawingControl: false,
            polygonOptions: {
                fillColor: "#a000a0",
                strokeWeight: 0,
                fillOpacity: 0.45,
                editable: true,
                zIndex: 10,
            },
        };
    }

    getPolygonGroups(): Group[] {
        this.clearPolygonGroups();
        this.polygonGroups = this.groupDataProvider.getMapGroups();
        angular.forEach(this.polygonGroups, (group) => {
            let viewOptionsGroups = this.viewOptions.groups.filter(
                (viewOptionsGroup: any) => {
                    return viewOptionsGroup.gid == group.gid;
                }
            );

            if (viewOptionsGroups.length <= 0) {
                this.viewOptions.groups.push({
                    gid: group.gid,
                    selected: true,
                });
            }
        });

        this.setAllPolygonColors();

        return this.polygonGroups;
    }

    setWindowOpts(windowOpts: any): void {
        this.windowOpts = windowOpts;
    }

    setProspectorMode(prospectorMode: boolean): void {
        let leavingProspector = this.prospectorMode && !prospectorMode;
        this.prospectorMode = prospectorMode;

        // An area drawn for Prospector stays on the map as a turf; count it
        // now, since its count was skipped while Prospector was open.
        if (leavingProspector && this.selectedPolygon) {
            this.getCountInPolygon();
        }
    }

    setGmap(gmap: any) {
        this.gmap = gmap;
    }

    setMap(map: any) {
        this.map = map;
    }

    getSelectedPolygon(): Group {
        return this.selectedPolygon;
    }

    getSelectedPolygonGroup(): Group {
        return this.selectedPolygonGroup;
    }

    polygonClicked(
        polygon: object,
        eventName: string = "",
        model: object = null,
        args: object = null,
        polygonGroup: Group = null
    ): void {
        let group: Group = polygonGroup ?? this.groupForPolygon(model);
        this.selectedPolygon = polygonGroup ?? polygon;
        this.selectedPolygon.points = polygonGroup
            ? polygonGroup.points
            : this.getPointsFromPolygon(this.selectedPolygon);
        this.selectedPolygonOriginalPoints = angular.copy(
            this.selectedPolygon.points
        );
        this.cancelDrawing = false;

        this.selectGroup(group);
    }

    multiPolygonClicked(group: Group = null): void {
        this.selectedPolygon = group;
        this.selectedPolygon.points = group.points;
        this.selectedPolygonOriginalPoints = angular.copy(
            this.selectedPolygon.points
        );
        this.cancelDrawing = false;

        this.selectGroup(group);
    }

    polygonBounds(polygon: any): any {
        let path = polygon.getPath();
        let bounds = new google.maps.LatLngBounds();
        angular.forEach(path, (value: any) => {
            bounds.extend(value);
        });
        return bounds;
    }

    groupForPolygon(polygon: any): Group {
        for (let i = 0; i < this.polygonGroups.length; i++) {
            const group = this.polygonGroups[i];
            if (group.isMultiPolygon()) {
                for (let j = 0; j < group.points.length; j++) {
                    if (angular.equals(group.points[j], polygon.path)) {
                        return group;
                    }
                }
            } else if (angular.equals(group.points, polygon.path)) {
                return group;
            }
        }
        return null;
    }

    getDrawingManagerOptions(): any {
        return {
            drawingControl: false,
            polygonOptions: {
                fillColor: "#a000a0",
                strokeWeight: 0,
                fillOpacity: 0.45,
                editable: true,
                zIndex: 10,
            },
        };
    }

    polygonsClickable(): boolean {
        return false;
    }

    getPolygonEvents(): any {
        return {
            overlaycomplete: (
                dm: any,
                name: any,
                scope: any,
                objs: Array<any>
            ) => {
                this.groupCountLoading = true;
                this.stopDrawingPolygonMode();
                this.selectedPolygon = objs[0].overlay;
                this.previousFilter = _.cloneDeep(
                    this.filterDataProvider.appliedFilter
                );

                if (
                    this.viewOptions.drawingMode == "polygon" &&
                    this.selectedPolygon
                ) {
                    this.polygonUpdate = this.$interval(() => {
                        this.handlePolygonInterval();
                    }, 300);

                    if (this.viewOptions.drawingMode == "polygon") {
                        this.savePolygonPoints();
                    }

                    this.getCountInPolygon();
                    this.drawingManagerControl
                        .getDrawingManager()
                        .setDrawingMode(null);
                } else {
                    this.$interval.cancel(this.polygonUpdate);
                }
            },
        };
    }

    selectGroup(group: Group): void {
        this.setAllPolygonColors();
        this.selectedPolygonGroup = group;
        this.setPolygonColor(group, true);
    }

    resetPolygons(): void {
        this.selectedPolygon = null;
        this.selectedPolygonGroup = null;
        this.setAllPolygonColors();
    }

    setAllPolygonColors() {
        if (this.polygonGroups && this.polygonGroups.length > 0) {
            angular.forEach(this.polygonGroups, (group) => {
                this.setPolygonColor(group, false);
            });
        }
    }

    setPolygonColor(group: Group, selected?: boolean): void {
        let color = "#696969";
        if (group.color && group.color != "") {
            color = angular.copy(group.color);
        }

        let fillOpacity: number = selected ? 0.85 : 0.55;
        let fillColor: string = selected ? this.darkenColor(color, -35) : color;
        let strokeWidth: number = selected ? 6 : 4;
        let strokeOpacity: number = selected ? 1 : 0.85;
        group["fillColor"] = {
            color: fillColor,
            opacity: fillOpacity,
        };
        group["strokeColor"] = {
            color: this.darkenColor(fillColor, -15),
            opacity: strokeOpacity,
            weight: strokeWidth,
        };
    }

    darkenColor(color, amount): string {
        // #FFF not supportet rather use #FFFFFF
        const clamp = (val) => Math.min(Math.max(val, 0), 0xff);
        const fill = (str) => ("00" + str).slice(-2);

        const num = parseInt(color.substr(1), 16);
        const red = clamp((num >> 16) + amount);
        const green = clamp(((num >> 8) & 0x00ff) + amount);
        const blue = clamp((num & 0x0000ff) + amount);
        return (
            "#" +
            fill(red.toString(16)) +
            fill(green.toString(16)) +
            fill(blue.toString(16))
        );
    }

    clearPolygonGroups(): void {
        this.polygonGroups.splice(0, this.polygonGroups.length);
    }

    handlePolygonInterval(): void {
        if (this.cancelDrawing) {
            this.$interval.cancel(this.polygonUpdate);
            return;
        }

        let points = this.getPointsFromPolygon(this.selectedPolygon);
        if (
            (points && points.length &&
                !angular.equals(points, this.selectedPolygon.points)) ||
            (this.previousFilter &&
                !angular.equals(
                    this.filterDataProvider.appliedFilter.nonEmptyValues(),
                    this.previousFilter.nonEmptyValues()
                ))
        ) {
            this.previousFilter = _.cloneDeep(
                this.filterDataProvider.appliedFilter
            );
            this.savePolygonPoints();
            this.getCountInPolygon();
        }
    }

    removePolygonGroup() {
        this.polygonGroups.splice(
            this.polygonGroups.indexOf(this.selectedPolygonGroup),
            1
        );
    }

    enableEditPolygonMode(group: Group, enable: boolean): void {
        if (enable) {
            this.getCountInPolygon();
            group["editable"] = true;
            this.windowOpts.type = "list";

            this.editPolygonModeActive = true;
            this.drawing = false;

            let highestPoint = {
                latitude: -90, // minimum latitude possible
                longitude: 0,
            };

            angular.forEach(this.selectedPolygon.getPath(), (point) => {
                if (point.lat() > highestPoint.latitude) {
                    highestPoint = {
                        latitude: point.lat(), // minimum latitude possible
                        longitude: point.lng(),
                    };
                }
            });

            this.windowOpts.coords = highestPoint;
            this.windowOpts.show = true;

            this.polygonUpdate = this.$interval(() => {
                if (this.cancelDrawing) {
                    this.$interval.cancel(this.polygonUpdate);
                    return;
                }

                if (!this.selectedPolygon) {
                    return;
                }

                let highestPoint = {
                    latitude: -90, // minimum latitude possible
                    longitude: 0,
                };

                angular.forEach(this.selectedPolygon.getPath(), (point) => {
                    if (point.lat() > highestPoint.latitude) {
                        highestPoint = {
                            latitude: point.lat(), // minimum latitude possible
                            longitude: point.lng(),
                        };
                    }
                });

                this.windowOpts.coords = highestPoint;

                this.selectedPolygon.points =
                    this.getPointsFromPolygon(this.selectedPolygon) ??
                    this.selectedPolygon.points;
                if (
                    !this.previousEditPolygonPoints ||
                    !angular.equals(
                        this.previousEditPolygonPoints,
                        this.selectedPolygon.points
                    ) ||
                    (this.previousFilter &&
                        !angular.equals(
                            this.filterDataProvider.appliedFilter.nonEmptyValues(),
                            this.previousFilter.nonEmptyValues()
                        ))
                ) {
                    this.previousEditPolygonPoints = angular.copy(
                        this.selectedPolygon.points
                    );
                    this.previousFilter = _.cloneDeep(
                        this.filterDataProvider.appliedFilter
                    );
                    this.getCountInPolygon();
                }
            }, 300);
        } else {
            group["editable"] = false;
            this.selectedPolygonGroup.points = angular.copy(
                this.selectedPolygonOriginalPoints
            );
            this.selectedPolygon.points = angular.copy(
                this.selectedPolygonOriginalPoints
            );
            this.$interval.cancel(this.polygonUpdate);
            this.previousEditPolygonPoints = null;
            this.windowOpts.show = false;
            this.windowOpts.coords = {
                latitude: this.selectedPolygon.points[0].latitude,
                longitude: this.selectedPolygon.points[0].longitude,
            };
            this.editPolygonModeActive = false;
        }
    }

    polygonStyleForGroup(groupPolygon: Group, type: string): object {
        if (groupPolygon == this.selectedPolygonGroup) {
            return this.styles.selected[type];
        } else if (
            groupPolygon.gstatus == "Active" ||
            groupPolygon.gstatus == "In Progress"
        ) {
            return this.styles.active[type];
        }
        return this.styles.done[type];
    }

    getCountInPolygon(): void {
        this.$rootScope.$broadcast("polygonUpdated", this.selectedPolygon);
        if (this.prospectorMode) {
            this.groupCountLoading = false;
        } else {
            if (this.cancelDrawing && !this.fromShape) return;
            this.groupCountLoading = true;

            let data = {
                filters: this.filterDataProvider.appliedFilter.nonEmptyValues(),
            };
            data["points"] = this.selectedPolygon.points;
            this.groupDataProvider.getCount(data).then(
                (group: Group) => {
                    this.groupCountLoading = false;
                    this.stopDrawingPolygonMode();
                    this.selectedPolygon.houses = group.houses;
                    this.selectedPolygon.houseoccupants = group.houseoccupants;
                },
                (error: object) => {
                    this.groupCountLoading = false;
                    this.windowOpts.show = false;
                    this.cancelDrawingPolygon();
                    this.toast.error();
                }
            );
        }
    }

    stopDrawingPolygonMode(): void {
        // this.drawingManagerControl.getDrawingManager().setDrawingMode(null);
        // this.drawing = false;
    }

    getPointsFromPolygon(polygon: any): object[] {
        if (polygon && polygon.getPath) {
            let points = [];
            angular.forEach(polygon.getPath(), (value: any, index: any) => {
                points.push({
                    latitude: value.lat(),
                    longitude: value.lng(),
                });
            });
            return points;
        }
        return null;
    }

    toggleDrawingMode(mode: string, enabled: boolean): void {
        if (mode != this.viewOptions.drawingMode || enabled != this.drawing) {
            if (enabled) {
                this.selectedPolygonGroup = null;
                this.viewOptions.drawingMode = mode;
                this.windowOpts.show = false;
                this.previousViewOptions = angular.copy(this.viewOptions);
                if (mode == "polygon") {
                    this.cancelFreeDrawMode();
                    this.startDrawing();
                } else if (mode == "freeDraw") {
                    this.viewOptions.mapStyleControls.landmarks = 0;
                    this.cancelPolygonDrawMode();
                    this.toggleFreeDrawingMode();
                }
            } else {
                this.viewOptions.mapStyleControls.landmarks = angular.copy(
                    this.previousViewOptions.mapStyleControls.landmarks
                );
                this.setFreeDrawingModeActive(false);
                this.cancelDrawingPolygon();
            }
        }
    }

    turfCreated(): void {
        this.windowOpts.show = false;
        if (this.drawing) {
            if (this.viewOptions.drawingMode == "polygon") {
                this.selectedPolygon.setMap(null);
                this.selectedPolygon = null;
            } else if (this.viewOptions.drawingMode == "freeDraw") {
                this.cancelFreeDrawMode();
                this.toggleFreeDrawingMode();
            }
        }
        this.fromShape = false;
    }

    cancelFreeDrawMode(): void {
        this.togglePanAndZoom(true);
        if (this.freeDrawPoly) {
            this.freeDrawPoly.setMap(null);
        }
        this.freeDrawPoly = null;
        this.drawingManagerControl.getDrawingManager().setDrawingMode(null);
        this.drawing = false;
        google.maps.event.clearListeners(this.gmap.getDiv(), "mousedown");
        google.maps.event.clearListeners(this.gmap.getDiv(), "touchstart");
        google.maps.event.clearListeners(this.gmap.getDiv(), "mouseup");
        google.maps.event.clearListeners(this.gmap.getDiv(), "mousemove");
    }

    cancelPolygonDrawMode(): void {
        this.$interval.cancel(this.polygonUpdate);
        this.drawingManagerControl.getDrawingManager().setDrawingMode(null);
        this.drawing = false;
        if (this.selectedPolygon) {
            try {
                if (this.selectedPolygon.constructor.name != "Group") {
                    this.selectedPolygon.setMap(null);
                }
                this.resetPolygons();
            } catch (ex) {
                console.log(ex);
            }
            this.selectedPolygon = null;
        }
    }

    togglePanAndZoom(bool: boolean): void {
        this.map.options.draggable = bool;
        this.map.options.zoomControl = bool;
        this.map.options.scrollwheel = bool;
        this.map.options.disableDoubleClickZoom = bool;
    }

    toggleFreeDrawingMode(): void {
        this.setFreeDrawingModeActive(true);
        this.drawing = true;
        this.togglePanAndZoom(false);
        this.map.options.draggableCursor = "crosshair";

        google.maps.event.addDomListener(
            this.gmap.getDiv(),
            "mousedown",
            (e) => {
                this.startFreeDrawing();
            }
        );
        google.maps.event.addDomListener(
            this.gmap.getDiv(),
            "touchstart",
            (e) => {
                this.startFreeDrawing();
            }
        );
    }

    startFreeDrawing(): void {
        if (!this.freeDrawPoly) {
            this.freeDrawPoly = new google.maps.Polyline({
                map: this.gmap,
                clickable: false,
                zIndex: 10,
            });

            this.freeDrawMoveListener = google.maps.event.addListener(
                this.gmap,
                "mousemove",
                (e) => {
                    if (this.freeDrawPoly) {
                        this.freeDrawPoly.getPath().push(e.latLng);
                    }
                }
            );

            google.maps.event.addListenerOnce(this.gmap, "mouseup", (e) => {
                google.maps.event.removeListener(this.freeDrawMoveListener);
                this.finishFreeDraw();
            });
        }
    }

    finishFreeDraw(): void {
        this.map.options.draggableCursor = "default";
        if (this.freeDrawPoly && this.freeDrawPoly.getPath()) {
            let path = this.freeDrawPoly.getPath();
            let points = [];
            angular.forEach(path, (value: any, index: any) => {
                points.push({
                    latitude: value.lat(),
                    longitude: value.lng(),
                });
            });

            google.maps.event.removeListener(this.freeDrawMoveListener);
            points = this.simplifyPath(points, this.map.zoom);
            if (points.length > 4) {
                this.windowOpts.type = "list";
                this.windowOpts.show = true;
                this.windowOpts.coords = points[0];

                this.freeDrawPoly.setMap(null);
                this.freeDrawPoly = new google.maps.Polygon({
                    map: this.gmap,
                    path: path,
                });

                this.selectedPolygon = this.freeDrawPoly;
                this.cancelDrawing = false;
                this.selectedPolygon.points = points;

                this.getCountInPolygon();

                google.maps.event.clearListeners(
                    this.gmap.getDiv(),
                    "mousedown"
                );

                google.maps.event.clearListeners(
                    this.gmap.getDiv(),
                    "touchstart"
                );

                this.togglePanAndZoom(true);
                this.setFreeDrawingModeActive(false);
            } else {
                this.cancelFreeDrawMode();
                this.toggleFreeDrawingMode();
            }
        } else {
            this.cancelFreeDrawMode();
            this.toggleFreeDrawingMode();
        }
    }

    polygonFromShape(path: any, properties: any = {}): void {
        let points = [];
        path.getArray().forEach((latLng: any) => {
            points.push({
                latitude: latLng.lat(),
                longitude: latLng.lng(),
            });
        });
        this.polygonFromPoints(points, properties);
    }
    multiPolygonFromShape(path: any, properties: any = {}): void {
        let paths = [];
        path.forEach((polygon: any) => {
            polygon.getArray().forEach((path: any) => {
                let points = [];
                path.getArray().forEach((latLng: any) => {
                    points.push({
                        latitude: latLng.lat(),
                        longitude: latLng.lng(),
                    });
                });
                paths.push(points);
            });
        });
        this.polygonFromMultiPoints(paths, properties);
    }

    polygonFromPoints(points: any[], properties: any = {}): void {
        let maxPoints: number = 3500;
        if (points.length > maxPoints) {
            const zoomLevelsForSimplificationAccuracy = [
                22, 20, 18, 16, 14, 12,
            ];

            for (const zoom of zoomLevelsForSimplificationAccuracy) {
                points = this.simplifyPath(points, zoom);
                if (points.length <= maxPoints) {
                    break;
                }
            }
        }

        if (points.length > 3) {
            this.windowOpts.type = "list";
            this.windowOpts.show = true;
            let highestPoint = points[0];
            angular.forEach(points, (point: any) => {
                if (point.latitude > highestPoint.latitude) {
                    highestPoint = point;
                }
            });

            this.windowOpts.coords = highestPoint;

            if (this.freeDrawPoly) {
                this.freeDrawPoly.setMap(null);
            }
            this.freeDrawPoly = new google.maps.Polygon({
                map: this.gmap,
                path: points,
            });

            this.selectedPolygon = this.freeDrawPoly;
            this.selectedPolygon.points = points;

            this.polygonProperties = properties;
            this.fromShape = true;
            this.getCountInPolygon();

            this.togglePanAndZoom(true);
            this.setFreeDrawingModeActive(false);
        }
    }

    polygonFromMultiPoints(pointsArray: any[][], properties: any = {}): void {
        // pointsArray is an array of arrays, each representing a polygon
        const paths = pointsArray.map((points) =>
            this.simplifyPath(points, this.map.zoom)
        );

        // Filter out invalid polygons
        const validPaths = paths.filter((points) => points.length > 3);

        if (validPaths.length > 0) {
            this.windowOpts.type = "list";
            this.windowOpts.show = true;

            // Find highest point in the first polygon for window options
            let highestPoint = validPaths[0][0];
            validPaths.forEach((points) => {
                points.forEach((point) => {
                    if (point.latitude > highestPoint.latitude) {
                        highestPoint = point;
                    }
                });
            });

            this.windowOpts.coords = highestPoint;

            if (this.freeDrawPoly) {
                this.freeDrawPoly.setMap(null);
            }

            // Create multipolygon by setting paths to an array of polygons
            this.freeDrawPoly = new google.maps.Polygon({
                map: this.gmap,
                paths: validPaths, // Setting paths as an array of arrays for multipolygon
            });

            this.selectedPolygon = this.freeDrawPoly;
            this.selectedPolygon.points = validPaths; // Storing all points

            this.polygonProperties = properties;
            this.fromShape = true;
            this.getCountInPolygon();

            this.togglePanAndZoom(true);
            this.setFreeDrawingModeActive(false);
        }
    }

    polygonVisible(group: Group): boolean {
        let viewOptionsGroup = this.viewOptions.groups.filter(
            (thisViewOptionsGroup: any) => {
                return group.gid == thisViewOptionsGroup.gid;
            }
        )[0];

        if (viewOptionsGroup) {
            return viewOptionsGroup.selected;
        }

        return false;
    }

    setFreeDrawingModeActive(bool: boolean): void {
        this.freeDrawingModeActive = bool;
    }

    isFreeDrawingModeActive(): boolean {
        return this.freeDrawingModeActive;
    }

    startDrawing(): void {
        this.windowOpts.type = "list";
        if (
            !this.turfCuttingFeatureGated ||
            this.permissionProvider.hasPermission("TURF_CUTTING")
        ) {
            this.cancelDrawingPolygon();
            this.drawing = true;
            this.cancelDrawing = false;
            this.drawingManagerControl
                .getDrawingManager()
                .setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
        } else {
            this.dialog.show({
                component: "vc-feature-restricted",
                escapeToClose: true,
                hasBackdrop: false,
                clickOutsideToClose: true,
                locals: {},
                ariaLabel: "Feature Restricted",
            });
        }
    }

    savePolygonPoints(): void {
        if (this.cancelDrawing) return;

        this.selectedPolygon.points = this.getPointsFromPolygon(
            this.selectedPolygon
        );
        if (this.selectedPolygon.points.length < 3) {
            this.cancelDrawingPolygon();
            this.toast.error(
                "Please note that a minimum of 3 points is required to create a shape."
            );
            return;
        }
        this.windowOpts.show = true;
        this.windowOpts.coords = {
            latitude: this.selectedPolygon.points[0].latitude,
            longitude: this.selectedPolygon.points[0].longitude,
        };
    }

    cancelDrawingPolygon(): void {
        this.cancelDrawing = true;
        this.map.options.draggableCursor = "default";
        this.cancelFreeDrawMode();
        this.cancelPolygonDrawMode();
        this.windowOpts.show = false;
    }

    discardDrawing(): void {
        this.$rootScope.$broadcast("polygonUpdated", this.selectedPolygon);
        if (this.selectedPolygon) {
            this.selectedPolygon.setMap(null);
        }
        this.selectedPolygon = null;
        this.windowOpts.show = false;

        this.cancelFreeDrawMode();
        this.toggleDrawingMode(this.viewOptions.drawingMode, !this.fromShape);
        this.fromShape = false;
    }

    polygonIsEditable(group: any): boolean {
        return group.editable == true;
    }

    pointsBoundsLiteral(points: object): object {
        let bounds = new google.maps.LatLngBounds();
        angular.forEach(points, (value: any) => {
            bounds.extend(
                new google.maps.LatLng(value.latitude, value.longitude)
            );
        });
        return {
            southwest: {
                latitude: bounds.getSouthWest().lat(),
                longitude: bounds.getSouthWest().lng(),
            },
            northeast: {
                latitude: bounds.getNorthEast().lat(),
                longitude: bounds.getNorthEast().lng(),
            },
        };
    }

    simplifyPath(
        source,
        zoom /* source[] Input coordinates in GLatLngs 	*/ /* kink	in metres, kinks above this depth kept  */ /* kink depth is the height of the triangle abc where a-b and b-c are two consecutive line segments */
    ) {
        let kink = 7;
        if (zoom >= 22) {
            kink = 0.2;
        }
        if (zoom >= 20) {
            kink = 0.5;
        }
        if (zoom >= 18) {
            kink = 1;
        } else if (zoom >= 16) {
            kink = 3;
        } else if (zoom >= 14) {
            kink = 5;
        }
        let n_source, n_stack, n_dest, start, end, i, sig;
        let dev_sqr, max_dev_sqr, band_sqr;
        let x12, y12, d12, x13, y13, d13, x23, y23, d23;
        let F = (Math.PI / 180.0) * 0.5;
        let index =
            []; /* aray of indexes of source points to include in the reduced line */
        let sig_start = []; /* indices of start & end of working section */
        let sig_end = [];

        /* check for simple cases */

        if (source.length < 3) return source; /* one or two points */

        /* more complex case. initialize stack */

        n_source = source.length;
        band_sqr =
            (kink * 360.0) / (2.0 * Math.PI * 6378137.0); /* Now in degrees */
        band_sqr *= band_sqr;
        n_dest = 0;
        sig_start[0] = 0;
        sig_end[0] = n_source - 1;
        n_stack = 1;

        /* while the stack is not empty  ... */
        while (n_stack > 0) {
            /* ... pop the top-most entries off the stacks */

            start = sig_start[n_stack - 1];
            end = sig_end[n_stack - 1];
            n_stack--;

            if (end - start > 1) {
                /* any intermediate points ? */

                /* ... yes, so find most deviant intermediate point to
                           either side of line joining start & end points */

                x12 = source[end].longitude - source[start].longitude;
                y12 = source[end].latitude - source[start].latitude;
                if (Math.abs(x12) > 180.0) x12 = 360.0 - Math.abs(x12);
                x12 *= Math.cos(
                    F * (source[end].latitude + source[start].latitude)
                ); /* use avg lat to reduce lng */
                d12 = x12 * x12 + y12 * y12;

                for (
                    i = start + 1, sig = start, max_dev_sqr = -1.0;
                    i < end;
                    i++
                ) {
                    x13 = source[i].longitude - source[start].longitude;
                    y13 = source[i].latitude - source[start].latitude;
                    if (Math.abs(x13) > 180.0) x13 = 360.0 - Math.abs(x13);
                    x13 *= Math.cos(
                        F * (source[i].latitude + source[start].latitude)
                    );
                    d13 = x13 * x13 + y13 * y13;

                    x23 = source[i].longitude - source[end].longitude;
                    y23 = source[i].latitude - source[end].latitude;
                    if (Math.abs(x23) > 180.0) x23 = 360.0 - Math.abs(x23);
                    x23 *= Math.cos(
                        F * (source[i].latitude + source[end].latitude)
                    );
                    d23 = x23 * x23 + y23 * y23;

                    if (d13 >= d12 + d23) dev_sqr = d23;
                    else if (d23 >= d12 + d13) dev_sqr = d13;
                    else
                        dev_sqr =
                            ((x13 * y12 - y13 * x12) *
                                (x13 * y12 - y13 * x12)) /
                            d12; // solve triangle

                    if (dev_sqr > max_dev_sqr) {
                        sig = i;
                        max_dev_sqr = dev_sqr;
                    }
                }

                if (max_dev_sqr < band_sqr) {
                    /* is there a sig. intermediate point ? */
                    /* ... no, so transfer current start point */
                    index[n_dest] = start;
                    n_dest++;
                } else {
                    /* ... yes, so push two subsections on stack for further processing */
                    n_stack++;
                    sig_start[n_stack - 1] = sig;
                    sig_end[n_stack - 1] = end;
                    n_stack++;
                    sig_start[n_stack - 1] = start;
                    sig_end[n_stack - 1] = sig;
                }
            } else {
                /* ... no intermediate points, so transfer current start point */
                index[n_dest] = start;
                n_dest++;
            }
        }

        /* transfer last point */
        index[n_dest] = n_source - 1;
        n_dest++;

        /* make return array */
        let r = [];
        for (let i: any = 0; i < n_dest; i++) r.push(source[index[i]]);
        return r;
    }
}
angular.module("map").service("PolygonService", PolygonService);
